import { render, staticRenderFns } from "./SolicitudCarguesMasivo.vue?vue&type=template&id=b1af8acc&scoped=true"
import script from "./SolicitudCarguesMasivo.vue?vue&type=script&lang=js"
export * from "./SolicitudCarguesMasivo.vue?vue&type=script&lang=js"
import style0 from "./SolicitudCarguesMasivo.vue?vue&type=style&index=0&id=b1af8acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1af8acc",
  null
  
)

export default component.exports